// extracted by mini-css-extract-plugin
export var activeIndex = "EbookHeroSection-module--activeIndex--fdde3";
export var cMarginTop = "EbookHeroSection-module--c-margin-top--2d6b9";
export var cPadding = "EbookHeroSection-module--c-padding--a5e69";
export var cPaddingBottom = "EbookHeroSection-module--c-padding-bottom--5d823";
export var cPaddingTop = "EbookHeroSection-module--c-padding-top--c9260";
export var checkboxWrapper = "EbookHeroSection-module--checkboxWrapper--40dbb";
export var container = "EbookHeroSection-module--container--6e7a9";
export var content = "EbookHeroSection-module--content--04f6f";
export var date = "EbookHeroSection-module--date--14bd6";
export var disabled = "EbookHeroSection-module--disabled--72390";
export var ellipsis = "EbookHeroSection-module--ellipsis--4cb2b";
export var error = "EbookHeroSection-module--error--67f0a";
export var featuredSection = "EbookHeroSection-module--featuredSection--5d2f6";
export var globalSpacing = "EbookHeroSection-module--global-spacing--bc07e";
export var globalSpacingBottom = "EbookHeroSection-module--global-spacing-bottom--3cb3f";
export var globalSpacingTop = "EbookHeroSection-module--global-spacing-top--7c1ca";
export var heroSection = "EbookHeroSection-module--heroSection--c9d8e";
export var image = "EbookHeroSection-module--image--43d98";
export var imageWrapper = "EbookHeroSection-module--imageWrapper--7b3e6";
export var index = "EbookHeroSection-module--index--35ff1";
export var left = "EbookHeroSection-module--left--20f73";
export var listItem = "EbookHeroSection-module--listItem--1286a";
export var maxWidth = "EbookHeroSection-module--max-width--888f7";
export var meta = "EbookHeroSection-module--meta--52822";
export var navButton = "EbookHeroSection-module--navButton--0a765";
export var pagination = "EbookHeroSection-module--pagination--9e749";
export var para = "EbookHeroSection-module--para--8c208";
export var points = "EbookHeroSection-module--points--8ae79";
export var right = "EbookHeroSection-module--right--d31ec";
export var styleTick = "EbookHeroSection-module--styleTick--91998";
export var submitButton = "EbookHeroSection-module--submitButton--92819";
export var subtitle = "EbookHeroSection-module--subtitle--94725";
export var success = "EbookHeroSection-module--success--64e2d";
export var tag = "EbookHeroSection-module--tag--5eca1";
export var tagWrapper = "EbookHeroSection-module--tagWrapper--0d05e";
export var title = "EbookHeroSection-module--title--0a97b";